import * as React from "react"

function LocationIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 21 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path
                d="M10.656 21.235l5.363-5.363a7.584 7.584 0 10-10.725 0l5.362 5.363zm0 3.063l-6.894-6.894a9.75 9.75 0 1113.789 0l-6.895 6.894zm0-11.622a2.166 2.166 0 100-4.332 2.166 2.166 0 000 4.332zm0 2.167a4.333 4.333 0 110-8.666 4.333 4.333 0 010 8.666z"
                className={
                    "fill-secondary-theme-200 dark:fill-[#83EDBF]"
                }
            />
        </svg>
    )
}

export default LocationIcon
